import React from "react";
import OrdersOverview from "@widgets/pos/orders/ordersOverview";


const PosOrders = () => {
    return <OrdersOverview/>;
};

export default PosOrders;